/*
 * App configurations
 */
const { REACT_APP_API_URL } = process.env;
export const API_URL = REACT_APP_API_URL;
export const TIMEOUT = 3000000;
